import React, { useEffect, useState } from "react";
import InputTextField from "../../../components/input/inputTextField";
import { Card, CardContent, Button, Chip, Typography } from "@mui/material";
import { colors } from "../../../constants/colors";
import { useTranslation } from "react-i18next";
import { icons } from "../../../assets/icons/icons";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { useDispatch } from "react-redux";
import { unsetLoading } from "../../../store/loading/loading.slice";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { EquipmentApi } from "../../../api/equipment/equipment.api";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";

const BookingDeviceManagementFormContainer = () => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id_device = queryParams.get("id_device");
  const prop_mode = queryParams.get("mode");

  const [inputValue, setInputValue] = useState<any>({
    id_device: "",
    device_no: "",
    device_name: "",
    device_unit: "",
    price_per_day_th: 0,
    price_per_day_usd: 0,
    status: 0,
  });

  const [image, setImage] = useState<any>(null);
  const [file, setFile] = useState<any>(null);
  const [mode, setMode] = useState<string>("VIEW");

  const handleChange = (name: string, value: string) => {
    setInputValue((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setFile(event.target.files);
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target) {
          setImage(e.target.result as string);
        }
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleDeleteImage = () => {
    setImage(null);
  };

  const getData = async (id_device?: number) => {
    try {
      if (id_device) {
        const res = await EquipmentApi.getEquipmentById(id_device);
        const data = res.data;

        if (data.status < 300) {
          setInputValue({
            id_device: data.data?.equipment?.id_equipment,
            device_no: data.data?.equipment?.equipment_no,
            device_name: data.data?.equipment?.equipment_name,
            device_unit: data.data?.equipment?.equipment_unit,
            price_per_day_th: data.data?.equipment?.external_service_fees,
            price_per_day_usd: data.data?.equipment?.internal_service_fees,
          });
          const pathFile =
            process.env.REACT_APP_FILE_BASE_API +
            "/" +
            data.data?.lastFile.file_path;
          setImage(pathFile);
        }
      } else {
        setInputValue({
          id_device: "",
          device_no: "",
          device_name: "",
          device_unit: "",
          price_per_day_th: 0,
          price_per_day_usd: 0,
        });
        setImage(null);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (id_device) {
      getData(+id_device);
    }
  }, [id_device]);

  useEffect(() => {
    if (prop_mode) {
      setMode(prop_mode ?? "CREATE");
    }
  }, [prop_mode]);

  const handleSave = async (newFile: File, body?: any, id_device?: number) => {
    if (newFile) {
      const title =
        prop_mode === "VIEW"
          ? "ข้อมูลอุปกรณ์"
          : prop_mode === "CREATE"
          ? "เพี่มอุปกรณ์"
          : prop_mode === "UPDATE"
          ? "แก้ไขอุปกรณ์"
          : "ข้อมูลอุปกรณ์";

      const formData = new FormData();

      formData.append("file", newFile);
      formData.append("equipment_no", body.device_no);
      formData.append("equipment_name", body.device_name);
      formData.append("equipment_unit", body.device_unit);
      formData.append("external_service_fees", body.price_per_day_th);
      formData.append("internal_service_fees", body.price_per_day_usd);
      formData.append("status", body.status);

      try {
        dispatch(unsetLoading());

        let response: any = {};

        if (id_device) {
          response = await EquipmentApi.updateEquipment(
            body.id_device,
            formData
          );
        } else {
          response = await EquipmentApi.createEquipment(formData);
        }

        if (response?.status < 300) {
          alertSuccess(`${title}`, `${title} เรียบร้อยแล้ว`, undefined, () => {
            getData();
            navigate(routeName.cms.BookingRoomDeviceManagement);
          });
        }
      } catch (error) {
        alertError(`${title} ไม่สำเร็จ`);
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  return (
    <>
      <NavigateListCustom
        navigateData={[
          {
            name: `จัดการอุปกรณ์`,
            key: "1",
            pathName: routeName.cms.BookingRoomDeviceManagement,
          },
          {
            name:
              prop_mode === "VIEW"
                ? "ข้อมูลอุปกรณ์"
                : prop_mode === "CREATE"
                ? "เพี่มอุปกรณ์"
                : prop_mode === "UPDATE"
                ? "แก้ไขอุปกรณ์"
                : "ข้อมูลอุปกรณ์",
            key: "2",
            pathName: "",
          },
        ]}
      />
      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{`${
          prop_mode === "VIEW"
            ? "ข้อมูลอุปกรณ์"
            : prop_mode === "CREATE"
            ? "เพี่มอุปกรณ์"
            : prop_mode === "UPDATE"
            ? "แก้ไขอุปกรณ์"
            : "ข้อมูลอุปกรณ์"
        }`}</Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-10">
        <article className="col-span-6 flex justify-center">
          <Card className="w-full flex flex-col items-center p-4">
            <CardContent className="flex flex-col items-center relative w-full">
              {image ? (
                <div className="relative w-full flex justify-center group">
                  <div className="w-full h-48 overflow-hidden">
                    <img
                      src={image}
                      alt="Uploaded"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  {mode !== "VIEW" && (
                    <Chip
                      label="X"
                      className="absolute top-2 right-2 hidden group-hover:flex cursor-pointer bg-red-500 text-white"
                      onClick={handleDeleteImage}
                    />
                  )}
                </div>
              ) : (
                <>
                  <span>
                    <img
                      width={48}
                      height={48}
                      src={icons.UploadCloudBig}
                      alt="icon"
                    />
                  </span>
                  <>
                    <Typography
                      sx={{
                        color: "#323539",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {t("FILE_UPLOAD.SELECT_FILE")}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(0,0,0,0.40)",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      สกุล png,jpg,jpeg ขนาดไม่เกิน 10MB
                    </Typography>
                  </>
                  <label htmlFor="upload-image">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                      id="upload-image"
                    />

                    <Button
                      variant="outlined"
                      sx={{
                        border: `1px solid ${colors.success3}`,
                        color: `${colors.success3}`,
                        textTransform: "none",
                      }}
                      color="primary"
                      onClick={() =>
                        document.getElementById("upload-image")?.click()
                      }
                    >
                      {t("BUTTON.SELECT_FILE")}
                    </Button>
                  </label>
                </>
              )}
            </CardContent>
          </Card>
        </article>

        {/* Form Section */}
        <article className="col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12 grid grid-cols-12 gap-4">
          {[
            { name: "device_no", label: "รหัสอุปกรณ์", type: "text" },
            { name: "device_name", label: "ชื่ออุปกรณ์", type: "text" },
            { name: "device_unit", label: "ชื่อหน่วย", type: "text" },
            {
              name: "price_per_day_th",
              label: "ค่าบริการสำหรับบุคคลภายนอก สกุลเงิน (THB) / วัน",
              type: "number",
            },
            {
              name: "price_per_day_usd",
              label: "ค่าบริการสำหรับบุคคลภายนอก สกุลเงิน (USD) / วัน",
              type: "number",
            },
          ].map((field, index) => (
            <article
              key={index}
              className="col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12"
            >
              <InputTextField
                heading={field.label}
                placeholder={field.label}
                type={field.type}
                value={inputValue[field.name]}
                disabled={mode === "VIEW"}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(field.name, e.target.value)
                }
              />
            </article>
          ))}
        </article>
      </div>

      <div className="mt-6 w-full flex justify-center gap-4 items-center">
        {mode === "VIEW" ? (
          <>
            <ButtonOutlined
              onClick={() => navigate(-1)}
              mode="del"
              buttonName="ย้อนกลับ"
            />
          </>
        ) : (
          <>
            <ButtonOutlined
              onClick={() => navigate(-1)}
              mode="del"
              buttonName="ย้อนกลับ"
            />

            {mode === "UPDATE" ? (
              <ButtonPrimary
                onClick={() => {
                  handleSave(
                    file ? file[0] : undefined,
                    inputValue,
                    id_device ? +id_device : undefined
                  );
                }}
                mode="next"
                buttonName={"บันทึก"}
              />
            ) : (
              <ButtonPrimary
                onClick={() => {
                  setMode("UPDATE");
                }}
                btnProps={{
                  bg: colors.orange,
                }}
                mode="next"
                buttonName={"แก้ไข"}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default BookingDeviceManagementFormContainer;
